import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { GetAuthenticatedSession } from '../helpers/get-authenticated-session';

export type GetAuthenticatedUserInfoFn = () => Promise<unknown>;

export function initGetAuthenticatedUserInfoFn({
    dependencies,
}: DomainInitPayload): GetAuthenticatedUserInfoFn {
    return async () => {
        return await GetAuthenticatedSession(dependencies);
    };
}
